import styled from 'styled-components';
import { Wrapper } from '../../../utils/atoms';
import {
  blue,
  lightBlue,
  brightBlue,
  darkerGrey,
  grey,
  white,
  black,
  tekoMedium,
  openSans,
  openSansLight,
  roboto,
} from '../../../utils/theme';
import { mobile } from '../../../utils/breakpoints';

export const Container = styled(Wrapper)`
  padding: 100px 70px;
  text-align: left;

  @media (max-width: ${mobile.max}px) {
    padding: 50px 30px;
    background-position: top right;
  }

  .section-title {
    @media (max-width: ${mobile.max}px) {
      img {
        width: 220px;
      }
    }
  }

  .hashtag {
    color: ${blue};
    ${tekoMedium} font-size: 38px;
    color: #26397e;
    letter-spacing: 2px;
    padding-top: 20px;

    .bright {
      color: ${brightBlue};
      text-transform: none;
    }

    @media (max-width: ${mobile.max}px) {
      font-size: 24px;
      letter-spacing: 2px;
    }
  }

  .tweet-form {
    position: relative;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    margin: 100px 0 125px 0;
    @media (max-width: ${mobile.max}px) {
      display: block;
    }
  }

  p {
    ${openSansLight} font-size: 14px;
    color: ${darkerGrey};
    letter-spacing: 1.4px;
    line-height: 22px;
    max-width: 580px;
    margin-top: 19px;
  }

  .input-wrapper {
    margin: 15px 30px 15px 0;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 500px;
    position: relative;

    @media (max-width: ${mobile.max}px) {
      display: block;
      margin: 30px auto 47px auto;

      input {
        &::placeholder {
          font-size: 24px;
        }
      }
    }
    
    .hint {
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 12px;
    }
  }

  .twitter-link {
    color: ${lightBlue};
  }

  input {
    padding: 0 0 14px 0;
    width: 100%;
    height: 54px;
    border-bottom: 1px solid ${blue};
    ${openSansLight} font-size: 38px;
    color: ${blue};

    &::placeholder {
      ${openSansLight} font-size: 38px;
      color: ${grey};
    }

    @media (max-width: ${mobile.max}px) {
      font-size: 20px;
      height: auto;
      padding-bottom: 7px;

      &::placeholder {
        font-size: 20px;
      }
    }
  }

  .tweetBtn {
    margin: 15px 0;

    @media (max-width: ${mobile.max}px) {
      display: block;
      position: relative;
      margin: 0 auto;
      width: 140px;
      font-size: 47px;
      text-align: center;
    }
  }
`;

export const Tweet = styled.div`
  width: 435px;
  max-width: calc(100% - 16px);
  padding: 26px 36px;
  position: relative;
  background: ${white};
  border: 2px solid #dcdcdc;

  .tweet-list__header {
    position: relative;
    padding-right: 30px;
  }

  .tweet-list__body {
  }

  .twitter-icon {
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .profile-icon {
    width: 35px;
    height: 35px;
    position: absolute;
    top: 0px;
    left: 0px;
  }

  h1 {
    ${roboto} font-size: 16px;
    color: ${blue};
    font-weight: 500;
    letter-spacing: 0.9px;
    line-height: 17px;
    margin-left: 45px;
    margin-bottom: 3px;
    overflow-wrap: break-word;
    text-transform: inherit;
  }

  .handle {
    margin-left: 45px;
    ${roboto} font-size: 14px;
    color: ${lightBlue};
    letter-spacing: 0.79px;
    line-height: 17px;
    overflow-wrap: break-word;
  }

  p {
    ${openSans}
    font-size: 14px;
    color: ${black};
    letter-spacing: 0.58px;
    line-height: 23px;
    margin-top: 16px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/fan-choice/styles/fan-choice.style.js